import styled from 'styled-components';

export const Wrapper = styled.div<{ $isVisible: boolean }>`
  display: flex;
  width: 140vw;
  height: 100%;
  ${({ $isVisible }) => !$isVisible && 'display: none;'}
  flex-direction: column;
  align-items: flex-start;
  overflow-y: auto;
  border-left: 1px solid ${({ theme }) => theme.colors.black4};
`;
